import React, {type ReactNode} from 'react'

type MarkdownTableProps = {children?: ReactNode}

/**
 * GFM table wrapper for react-markdown / assistant-ui markdown overrides.
 * Shrink-wraps to column content (left-aligned). Horizontal scroll on the wrap
 * keeps wide comparison tables inside the message.
 */
export const OmicsMarkdownTable: React.FC<MarkdownTableProps> = ({children}) => (
  <div className='omics-md-table-wrap' data-testid='omics-md-table-wrap'>
    <table className='omics-md-table'>{children}</table>
  </div>
)

export const omicsMarkdownTableComponents = {
  table: OmicsMarkdownTable,
}
